export default function getSchema(vm) {
  return {
    Email: {
      visible: true,
      mnemonic: "contactcard",
      editor: {
        Name: "Email",
        Required: true,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.email'),
      },
      component: { Name: 'EmailAddress' }
    },
    Password: {
      visible: true,
      editor: {
        Name: "Password",
        Required: true,
        value: "",
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.password'),
      },
      component: { Name: 'Password' }
    },
    LastName: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Name: "LastName",
        Required: true,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.surname'),
      },
      component: { Name: 'String' }
    },
    FirstName: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Name: "FirstName",
        Required: true,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.name'),
      },
      component: { Name: 'String' }
    },
    MiddleName: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.middleName'),
      },
      component: { Name: 'String' }
    },
    Gender: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.sex'),
      },
      component: {
        Name: 'Enum',
        Params: {
          Type: "Visary.Abstractions.Enums.Gender"
        }
      },
    },
    BirthDate: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.birthDate'),
      },
      component: {
        Name: 'Date'
      },
    },
    AvatarUrl: {
      visible: false,
      mnemonic: "personcard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.photo'),
      },
      component: {
        Name: 'FileStorageLink',
        Params: {
          ViewType: "Card",
          LinkType: "ById",
          DriveName: "Images",
          FolderPath: "/Users",
          IsOwnedDrive: true,
          IsPrimaryDrive: true,
          UploadButtonHidden: false,
          AllowTypes: [
            "png",
            "jpg",
            "jpeg",
            "gif",
            "webp",
            "svg"
          ]
        }
      },
    },
    Address: {
      visible: false,
      mnemonic: "addresscard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.address'),
      },
      component: {
        Name: 'Address'
      },
    },
    Phone: {
      visible: false,
      mnemonic: "contactcard",
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.phone'),
      },
      component: {
        Name: 'String'
      },
    },
    WebSite: {
      mnemonic: "contactcard",
      visible: false,
      editor: {
        Required: false,
        value: null,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.website'),
      },
      component: {
        Name: 'String'
      },
    },
    EmailNotification: {
      visible: false,
      mnemonic: "settingscard",
      editor: {
        Required: false,
        value: true,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.emailNotification'),
      },
      component: {
        Name: 'Boolean'
      },
    },
    SMSNotification: {
      visible: false,
      mnemonic: "settingscard",
      editor: {
        Required: false,
        value: false,
      },
      element: {
        LabelVisible: true,
        TextAlign: 'left',
        Text: vm.$t('previewAccessUserModal.smsNotification'),
      },
      component: {
        Name: 'Boolean'
      },
    }
  }
}